export const MOCK_DATA: Record<string, any>[] = [
  {
    "is_active": true,
    "machine_name": "test_create_mock_org",
    "metadata_schema_type": "",
    "name": "TestCreateMockOrg",
    "id": "62f17051-00f6-4e2e-90fe-3f80981e27f4",
    "organization_id": "dcfe3d70-69cc-4159-aab0-bcf435707028",
    "created_date": "2026-07-30T03:16:52.984Z",
    "updated_date": "2026-07-30T03:16:52.984Z",
    "primary_organization_email_address": null,
    "created_by": null,
    "updated_by": null,
    "okta_group_id": "afd05fa4-1968-4cec-8576-10a8efc940ba",
    "okta_application_id": "7ac351f1-508d-4dc1-875e-fce7dbe5729b"
  }
];